import Header from "components/Header/Header"
import AppButton from "components/StyledComponents/AppButton"
import { createBreadcrumbs } from "helpers/breadCrumbs"
import React, { Fragment, useEffect, useState } from "react"
import { Container, Row, Col } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import classes from "../../menu.module.scss"
import MenuListContainer from "../../../../../../components/menuListContainer/index"
import {
  getReviewBarMenuPeriodAction,
  getReviewMenuPeriodAction,
  getReviewWineMenuPeriodAction,
  getReviewSpiritCMSAction,
  getReviewMenuSubCategoryAction
} from "redux/marketing/actions"
import { Typography, Grid, InputAdornment } from "@mui/material"
import { useHistory } from "react-router-dom"
import { useTheme } from "@mui/system"
import { marketingActions } from "redux/marketing/slice/user"
import CategoryModal from "../../EditMenu/components/CategoryModal"
import MenuNavBar from "components/menuNavBar"
import SubMenuBar from "components/subMenuBar"
import WineListItems from "components/WineListItems"
import BarListItems from "components/BarListItem"
import BarMenuCategoryModal from "../../EditMenu/components/BarMenuCategoryModal"
import SpiritsMenuListContainer from "components/spiritsMenuListConatiner"
import { getNewSpiritCountAction } from "redux/marketing/actions/user"
import SpiritsSubMenuBar from "components/SpiritsSubMenuBar"
import DMVAddMenuItems from "pages/private/DVM_Console/DMV_Menu/AddDMVMenuItems"
import AddMenuItems from "../../AddMenuItems"
import DMV_SpiritSummary from "components/DMVSpiritSummary"
import { getDynamicMenuFieldsAction } from "redux/superAdmin/actions"
import { toTitleCase } from "helpers/functions"
import WineCategoryModal from "../../EditMenu/components/WineCategoryModal"
import { useDebounce } from "hooks/utils"
import SearchTextField from "components/StyledComponents/SearchTextField"
import SearchIcon from "@mui/icons-material/Search"
import WineBottleListItems from "components/WineBottleListItems"
import { Masonry } from "@mui/lab"
import MobilePreview from "components/MobilePreview"

const menuText = {
  DINNER: "dinner",
  LUNCH: "lunch",
  BRUNCH: "brunch",
  BREAKFAST: "breakfast",
  BARMENU: "bar menu",
  WINEBAR: "wine by glass",
  SPIRITS: "spirits",
  WINEBOTTLE: "wine by bottle",
  SPECIALS: "specials"
}

function EditReviewMenu() {
  const [breadCrumbs, setBreadcrumbs] = useState([])
  const dispatch = useDispatch()
  const theme = useTheme()
  const history = useHistory()
  const [categoryModal, setCategoryModal] = useState(false)
  const [isEdit] = useState(true)
  const [currentCategoryData, setCurrentCategoryData] = useState({})
  const [isEditModal, setIsEditModal] = useState(false)
  const [isEditModalItem, setIsEditModalItem] = useState(false)
  const [menuItemsModal, setMenuItemsModal] = useState(false)
  const { linkCategory } = useSelector((state) => state?.marketing?.menu || {})
  const {
    reviewMenuPeriod,
    reviewBarMenuPeriod,
    reviewWineMenuPeriod,
    reviewSpiritData,
    reviewMenuSubCategory
  } = useSelector((state) => state?.marketing?.menu || {})
  const { menuCategory, SpiritSubMenu } = useSelector((state) => state.dmv)
  const [searchValue, setSearchValue] = useState("")
  const debouncedSearchTerm = useDebounce(searchValue, 500)
  const [menuItems, setMenuItems] = useState(reviewMenuPeriod)
  const [barItems, setBarItems] = useState(reviewBarMenuPeriod)
  const [wineItems, setWineItems] = useState(reviewWineMenuPeriod)
  const [spiritItems, setSpiritItems] = useState(reviewSpiritData)
  const [openPreviewModal, setOpenPreviewModal] = useState(false)

  const handleSearchField = (e) => {
    setSearchValue(e.target.value)
  }

  const handleRouting = () => {
    const itemsLink = {
      item: linkCategory?.item,
      category: reviewMenuSubCategory?.[0]?.name || "",
      list: "Summary View"
    }
    dispatch(marketingActions.setMenuLink(itemsLink))
    history.push("/marketing/dashboard/explore-menu/review-menu")
  }

  function handleCloseMenuItems() {
    setMenuItemsModal(false)
    setIsEditModalItem(false)
    dispatch(marketingActions.setFoodItemsDetail({}))
  }

  useEffect(() => {
    setBreadcrumbs(createBreadcrumbs())
    document.title = "Edit Review Menu"
    return () => dispatch(marketingActions.setFoodItemsDetail({}))
  }, [])

  useEffect(() => {
    if (linkCategory?.item === menuText.BARMENU) {
      dispatch(getReviewBarMenuPeriodAction())
    } else if (
      linkCategory?.item === menuText.WINEBAR ||
      linkCategory?.item === menuText.WINEBOTTLE
    ) {
      dispatch(getReviewWineMenuPeriodAction())
    } else if (linkCategory?.item === menuText.SPIRITS) {
      dispatch(getReviewSpiritCMSAction())
      dispatch(getNewSpiritCountAction())
    } else {
      dispatch(getReviewMenuSubCategoryAction())
      dispatch(getReviewMenuPeriodAction())
    }
    setSearchValue("")
    dispatch(getDynamicMenuFieldsAction({ category: toTitleCase(linkCategory?.item) }))
  }, [linkCategory?.item, linkCategory?.category, menuCategory])

  function filterResults(searchQuery, results, menuType) {
    const trimmedQuery = searchQuery.trim().toLowerCase()

    if (!trimmedQuery) {
      return results
    }

    const isSpiritsMenu = menuType === menuText.SPIRITS
    const listKey = isSpiritsMenu ? "spirit_list" : "food_list"
    const categoryKey = isSpiritsMenu ? "spirit_category" : "food_category"

    return results
      ?.map((period) => {
        const category = period[categoryKey]?.toLowerCase()
        const isCategoryMatch = category.includes(trimmedQuery)

        if (isCategoryMatch) {
          return period
        }

        const filteredList = period[listKey]?.filter((item) => {
          const nameMatch = item?.name?.toLowerCase().includes(trimmedQuery)

          const ingredientsField = item?.data_to_display?.find(
            (field) => field.filedName === "Ingredients" || field.filedName === "Ingredient"
          )
          let ingredientMatch
          if (isSpiritsMenu) {
            ingredientMatch = item?.ingredient?.some((ingredient) =>
              ingredient?.name?.toLowerCase().includes(trimmedQuery)
            )
          } else {
            ingredientMatch = Array.isArray(ingredientsField?.value)
              ? ingredientsField.value.some((ingredient) =>
                  ingredient.name.toLowerCase().includes(trimmedQuery)
                )
              : ingredientsField?.value.toLowerCase().includes(trimmedQuery)
          }

          return nameMatch || ingredientMatch
        })

        return filteredList?.length > 0 ? { ...period, [listKey]: filteredList } : null
      })
      .filter(Boolean)
      .sort((a, b) => {
        const categoryA = a[categoryKey].toLowerCase()
        const categoryB = b[categoryKey].toLowerCase()

        if (categoryA === trimmedQuery) return -1
        if (categoryB === trimmedQuery) return 1

        if (categoryA.startsWith(trimmedQuery) && !categoryB.startsWith(trimmedQuery)) return -1
        if (!categoryA.startsWith(trimmedQuery) && categoryB.startsWith(trimmedQuery)) return 1

        return categoryA.localeCompare(categoryB)
      })
  }

  useEffect(() => {
    const menuMap = {
      [menuText.BARMENU]: {
        data: reviewBarMenuPeriod,
        setFunction: setBarItems
      },
      [menuText.WINEBAR]: {
        data: reviewWineMenuPeriod,
        setFunction: setWineItems
      },
      [menuText.WINEBOTTLE]: {
        data: reviewWineMenuPeriod,
        setFunction: setWineItems
      },
      [menuText.SPIRITS]: {
        data: reviewSpiritData,
        setFunction: setSpiritItems
      },
      default: {
        data: reviewMenuPeriod,
        setFunction: setMenuItems
      }
    }

    const { data, setFunction } = menuMap[linkCategory?.item] || menuMap.default
    const filteredResults = filterResults(debouncedSearchTerm, data, linkCategory?.item)
    setFunction(filteredResults)
  }, [
    reviewBarMenuPeriod,
    reviewWineMenuPeriod,
    reviewSpiritData,
    reviewMenuPeriod,
    linkCategory?.item,
    menuCategory?.name,
    linkCategory?.category,
    debouncedSearchTerm
  ])

  return (
    <Fragment>
      <MobilePreview open={openPreviewModal} handleClose={() => setOpenPreviewModal(false)} />
      {linkCategory?.item === menuText?.SPIRITS ? (
        <DMVAddMenuItems
          isEdit={isEditModalItem}
          open={menuItemsModal}
          onClose={handleCloseMenuItems}
          isReviewMode={true}
          isCMS={true}></DMVAddMenuItems>
      ) : (
        <AddMenuItems
          isEdit={isEditModalItem}
          open={menuItemsModal}
          onClose={handleCloseMenuItems}
          isReviewMode={true}
        />
      )}
      {linkCategory?.item !== menuText.BARMENU &&
        linkCategory?.item !== menuText.SPIRITS &&
        linkCategory?.item !== menuText.WINEBAR &&
        linkCategory?.item !== menuText.WINEBOTTLE && (
          <CategoryModal
            data={currentCategoryData}
            isEdit={isEditModal}
            open={categoryModal}
            setMenuItemsModal={setMenuItemsModal}
            onClose={setCategoryModal}></CategoryModal>
        )}
      {linkCategory?.item === menuText.BARMENU && (
        <BarMenuCategoryModal
          data={currentCategoryData}
          isEdit={isEditModal}
          open={categoryModal}
          setMenuItemsModal={setMenuItemsModal}
          onClose={setCategoryModal}></BarMenuCategoryModal>
      )}
      {linkCategory?.item === menuText.WINEBAR && (
        <WineCategoryModal
          data={currentCategoryData}
          isEdit={isEditModal}
          open={categoryModal}
          setMenuItemsModal={setMenuItemsModal}
          label="Wine"
          onClose={setCategoryModal}
        />
      )}
      {linkCategory?.item === menuText.WINEBOTTLE && (
        <WineCategoryModal
          data={currentCategoryData}
          isEdit={isEditModal}
          open={categoryModal}
          setMenuItemsModal={setMenuItemsModal}
          label="Wine By Bottle"
          onClose={setCategoryModal}
        />
      )}
      <Container fluid className="p-0">
        <Row>
          <Col lg="12">
            <Header title={`Edit Review Menu`} breadCrumbs={breadCrumbs}>
              <div className="d-flex align-items-center">
                <AppButton
                  styles={{
                    backgroundColor: theme.palette.background.main,
                    padding: "12px 25px"
                  }}
                  variant="filled"
                  onClick={handleRouting}>
                  Done
                </AppButton>
              </div>
            </Header>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col lg="12">
            <MenuNavBar
              isEdit={isEdit}
              isReviewMode={true}
              activeTab={linkCategory?.item}
              subCategory={reviewMenuSubCategory?.[0]?.name}></MenuNavBar>
          </Col>
        </Row>
        {(linkCategory?.item === menuText.DINNER ||
          linkCategory?.item === menuText.LUNCH ||
          linkCategory?.item === menuText.BRUNCH ||
          linkCategory?.item === menuText.BREAKFAST ||
          linkCategory?.item === menuText.SPECIALS) && (
          <Row className="mt-4">
            <Col lg="12">
              <SubMenuBar
                isEdit={isEdit}
                isReviewMode={true}
                activeTab={linkCategory?.category}
                menu={reviewMenuSubCategory}></SubMenuBar>
            </Col>
          </Row>
        )}
        {linkCategory?.item === menuText.SPIRITS && (
          <Row className="mt-4">
            <Col lg={12}>
              <SpiritsSubMenuBar isCMS={true} activeTab={menuCategory?.name} isEdit={true} />
            </Col>
          </Row>
        )}
      </Container>
      <Container fluid className="p-0">
        <Row className="m-0 mt-2 mb-4 pb-2" style={{ borderBottom: "1px solid gray" }}>
          <Col lg="12" className="p-0 d-flex justify-content-between align-items-center">
            <Typography variant="h2">
              {linkCategory?.item === menuText.DINNER ||
              linkCategory?.item === menuText.LUNCH ||
              linkCategory?.item === menuText.BRUNCH ||
              linkCategory?.item === menuText.BREAKFAST
                ? linkCategory?.category
                : ""}
            </Typography>
          </Col>
        </Row>
        <Row className={"mb-2"}>
          <Col lg="4">
            <SearchTextField
              id="search"
              name="search"
              value={searchValue}
              onChange={handleSearchField}
              fullWidth
              type="search"
              placeholder="Search menu items or ingredients"
              InputProps={{
                disableUnderline: true,
                endAdornment: (
                  <InputAdornment
                    position="end"
                    sx={{
                      backgroundColor: theme.palette.primary.main
                    }}>
                    <SearchIcon htmlColor={`${theme.palette.text.secondary}`} />
                  </InputAdornment>
                )
              }}
              style={{
                border: `1px solid ${theme.palette.text.secondary}`,
                backgroundColor: theme.palette.primary.main,
                borderRadius: 6
              }}
            />
          </Col>
        </Row>
        {linkCategory?.item !== menuText.BARMENU &&
          linkCategory?.item !== menuText.SPIRITS &&
          linkCategory?.item !== menuText.WINEBOTTLE &&
          linkCategory?.item !== menuText.WINEBAR && (
            <Masonry columns={2} spacing={2}>
              {menuItems?.length > 0 ? (
                menuItems?.map((menuItem, idx) => {
                  return (
                    <MenuListContainer
                      setMenuItemsModal={setMenuItemsModal}
                      setCurrentCategoryData={setCurrentCategoryData}
                      setIsEdit={setIsEditModal}
                      setIsEditModalItem={setIsEditModalItem}
                      setCategoryModal={setCategoryModal}
                      setOpenPreviewModal={setOpenPreviewModal}
                      isEdit={isEdit}
                      isReviewMode={true}
                      data={menuItem}
                      key={idx}
                    />
                  )
                })
              ) : (
                <Typography>
                  {searchValue ? "No items found matching your search" : "No Data Found"}
                </Typography>
              )}
            </Masonry>
          )}
        {linkCategory?.item === menuText.BARMENU && (
          <Masonry columns={2} spacing={2}>
            {barItems?.length > 0 ? (
              barItems?.map((menuItem, idx) => {
                return (
                  <BarListItems
                    isEdit={isEdit}
                    isReviewMode={true}
                    data={menuItem}
                    key={idx}
                    setMenuItemsModal={setMenuItemsModal}
                    setCurrentCategoryData={setCurrentCategoryData}
                    setIsEdit={setIsEditModal}
                    setIsEditModalItem={setIsEditModalItem}
                    setCategoryModal={setCategoryModal}
                    setOpenPreviewModal={setOpenPreviewModal}
                  />
                )
              })
            ) : (
              <Typography>
                {searchValue ? "No items found matching your search" : "No Data Found"}
              </Typography>
            )}
          </Masonry>
        )}
        {linkCategory?.item === menuText.WINEBAR && (
          <Masonry columns={2} spacing={2}>
            {wineItems?.length > 0 ? (
              wineItems?.map((menuItem, idx) => {
                return (
                  <WineListItems
                    isEdit={isEdit}
                    isReviewMode={true}
                    data={menuItem}
                    key={idx}
                    setCurrentCategoryData={setCurrentCategoryData}
                    setIsEdit={setIsEditModal}
                    setCategoryModal={setCategoryModal}
                    setOpenPreviewModal={setOpenPreviewModal}
                  />
                )
              })
            ) : (
              <Typography>
                {searchValue ? "No items found matching your search" : "No Data Found"}
              </Typography>
            )}
          </Masonry>
        )}
        {linkCategory?.item === menuText.WINEBOTTLE && (
          <Masonry columns={2} spacing={2}>
            {wineItems?.length > 0 ? (
              wineItems?.map((menuItem, idx) => {
                return (
                  <WineBottleListItems
                    isEdit={isEdit}
                    isReviewMode={true}
                    data={menuItem}
                    key={idx}
                    setCurrentCategoryData={setCurrentCategoryData}
                    setIsEdit={setIsEditModal}
                    setCategoryModal={setCategoryModal}
                    setOpenPreviewModal={setOpenPreviewModal}
                  />
                )
              })
            ) : (
              <Typography>
                {searchValue ? "No items found matching your search" : "No Data Found"}
              </Typography>
            )}
          </Masonry>
        )}
        {linkCategory?.item === menuText.SPIRITS && (
          <>
            <Grid item sx={{ maxWidth: "50%" }}>
              {SpiritSubMenu?.map(
                (foodList, i) =>
                  foodList?.id === menuCategory?.name &&
                  (foodList?.description ||
                    foodList?.image_url ||
                    foodList?.unique_facts?.length > 0) && (
                    <DMV_SpiritSummary key={i} isEdit={false} foodList={foodList} isCMS={true} />
                  )
              )}
            </Grid>
            <Container fluid className="p-0 mt-4">
              <div className={classes.spiritContainer}>
                {spiritItems?.length > 0 ? (
                  spiritItems?.map((menuItem, idx) => {
                    return (
                      <SpiritsMenuListContainer
                        setMenuItemsModal={setMenuItemsModal}
                        setCurrentCategoryData={setCurrentCategoryData}
                        setIsEdit={setIsEditModal}
                        setIsEditModalItem={setIsEditModalItem}
                        setCategoryModal={setCategoryModal}
                        isReviewMode={true}
                        isEdit={isEdit}
                        data={menuItem}
                        key={idx}
                      />
                    )
                  })
                ) : (
                  <Typography>
                    {searchValue ? "No items found matching your search" : "No Data Found"}
                  </Typography>
                )}
              </div>
            </Container>
          </>
        )}
      </Container>
    </Fragment>
  )
}

export default EditReviewMenu
